import React, { useState } from "react";
import { generatePassword } from "../utils/passwordGenerator";
import { PasswordGeneratorProps, SubtitleEntry } from "../types";
import "./PasswordGenerator.css";

const PasswordGenerator: React.FC<PasswordGeneratorProps> = ({ subtitles }) => {
  const [currentLine, setCurrentLine] = useState<SubtitleEntry | null>(null);
  const [password, setPassword] = useState<string>("");
  const [copied, setCopied] = useState<boolean>(false);

  const handleGeneratePassword = (): void => {
    const minPasswordLength = 8;
    let password = "";
    let combinedText = "";
    const startIndex = Math.floor(Math.random() * subtitles.length);
    let i = startIndex;

    const firstSubtitle = subtitles[startIndex];
    let endTime = firstSubtitle.endTime;

    while (password.length < minPasswordLength && i < subtitles.length) {
      const subtitle = subtitles[i];
      combinedText += " " + subtitle.text;
      endTime = subtitle.endTime;
      password = generatePassword(combinedText.trim());
      i++;
    }

    setCurrentLine({
      id: firstSubtitle.id,
      startTime: firstSubtitle.startTime,
      endTime,
      text: combinedText.trim(),
    });

    setPassword(password);
    setCopied(false);
  };

  const handleCopyPassword = (): void => {
    navigator.clipboard
      .writeText(password)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const formatTimestamp = (timestamp: string): string => {
    const parts = timestamp.split(":");
    if (parts.length >= 3) {
      const hours = parts[0];
      // Get minutes
      const minutes = parts[1];
      // Get seconds (remove milliseconds)
      const seconds = parts[2].split(",")[0];
      return `${hours}:${minutes}:${seconds}`;
    }
    return timestamp;
  };

  return (
    <div className="password-generator">
      <button className="generate-btn" onClick={handleGeneratePassword}>
        Generate Password
      </button>

      {currentLine && (
        <div className="password-container">
          <div className="movie-reference">
            <div className="timestamp">
              <span>Movie Timestamp: </span>
              <strong>
                {formatTimestamp(currentLine.startTime)} -{" "}
                {formatTimestamp(currentLine.endTime)}
              </strong>
            </div>

            <div className="dialogue">
              <p>"{currentLine.text}"</p>
              <div className="memory-tip">
                <strong>Tip:</strong> Break out your Digital Video Disc(DVD)
                copy of the movie and skip to this line to listen and memorise
                it.
              </div>
            </div>
          </div>

          <div className="password-result">
            <h3>Your Password:</h3>
            <div className="password-display">
              {password}
              <button className="copy-btn" onClick={handleCopyPassword}>
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
            <p className="password-tip">
              What a lovely password, memorise the quote just be sure not to
              repeat it too often!
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PasswordGenerator;
